var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable } from 'mobx';
export class NotationStore {
    //@observable public rootStore: RootStore;
    //constructor(rootStore: RootStore) {
    //this.rootStore = rootStore;
    //}
    get visible() {
        return !!this.anchorObj;
    }
    setActiveItem(anchorObj, title, body) {
        this.anchorObj = anchorObj;
        this.title = title;
        this.body = body;
    }
    clear() {
        this.anchorObj = null;
        this.title = '';
        this.body = '';
    }
}
__decorate([
    observable
], NotationStore.prototype, "anchorObj", void 0);
__decorate([
    observable
], NotationStore.prototype, "title", void 0);
__decorate([
    observable
], NotationStore.prototype, "body", void 0);
__decorate([
    computed
], NotationStore.prototype, "visible", null);
__decorate([
    action
], NotationStore.prototype, "setActiveItem", null);
__decorate([
    action
], NotationStore.prototype, "clear", null);
